import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'
import { BulkAddBarStyleProps } from './BulkAddBar'

export const useBulkAddBarStyles = makeStyles((theme: Theme) => ({
    searchBarContainer: {
        position: 'absolute',
        top: (props: BulkAddBarStyleProps) =>
            props.isBetaWorkspaceToggleEnabled ? pxToRem(14) : pxToRem(17),
        backgroundColor: 'transparent',
    },
    searchFieldContainer: {
        width: '50%',
        height: pxToRem(35),
        marginLeft: theme.spacing(2.8),
        borderRadius: pxToRem(4),
        '@media (max-width: 1024px)': {
            width: '45%',
        },
    },
    closeIcon: (props: BulkAddBarStyleProps) => ({
        color: '#1d5f8c',
        fontSize: props.isBetaWorkspaceToggleEnabled
            ? pxToRem(24)
            : pxToRem(26),
        top: props.isBetaWorkspaceToggleEnabled ? 0 : pxToRem(0.5),
        position: 'absolute',
        cursor: 'pointer',
    }),
    elementTypeButton: {
        backgroundColor: theme.palette.common.white,
        color: '#314959',
        border: '1px solid #314959',
        borderRadius: pxToRem(100),
        padding: '6px 10px',
    },
    selectedElementsButton: {
        width: 204,
        height: 26,
        fontSize: pxToRem(12),

        '&:hover': {
            backgroundColor: theme.palette.common.white,
        },
    },
    elementTypeItem: {
        '@media (max-width: 1024px)': {
            paddingLeft: theme.spacing(1.25),
        },
        paddingRight: (props: BulkAddBarStyleProps) =>
            props.isBetaWorkspaceToggleEnabled ? pxToRem(12) : pxToRem(20),
    },
    rightSideContents: {
        maxWidth: '40%',
        top: pxToRem(1),
        position: 'relative',
        right: pxToRem(8),
        '@media (max-width: 1024px)': {
            maxWidth: '50%',
        },
    },
    checkIcon: {
        color: '#33B55B',
    },
    elementTypeItems: {
        marginRight: theme.spacing(3),
    },
    confirmationText: {
        fontSize: pxToRem(12),
        color: '#314959',
        fontWeight: 500,

        marginBottom: theme.spacing(0.5),
    },
    startIcon: {
        fontSize: pxToRem(16) + '!important',
    },
    bulkAddBarContainer: {
        marginTop: theme.spacing(1.25),
        paddingTop: theme.spacing(1.25),
        borderTop: '1px solid #DDDDDD',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
    },
    clearText: {
        color: '#185E8E',
        fontSize: pxToRem(12),
        position: 'absolute',
        right: theme.spacing(1.25),
        top: theme.spacing(1.25),
        fontWeight: 500,
        cursor: 'pointer',
    },
}))
